<template>
  <div>
    <div class="body">
      <div class="search">
        <div class="item">
          <el-input v-model="datas.user_id" placeholder="客户ID" clearable></el-input>
        </div>
        <div class="item">
          <el-input v-model="datas.keyword" :placeholder="$t('message.FuzzySearchHistoricalRecords')"
            clearable></el-input>
        </div>
        <!-- 开始日期-->
        <div class="item">
          <el-date-picker v-model="datas.datetimeStart" :placeholder="$t('message.startDate')" class="Container"
            type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--  结束日期-->
        <div class="item">
          <el-date-picker v-model="datas.datetimeEnd" :placeholder="$t('message.dateClosed')" class="Container"
            default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div class="item">
          <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>

        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 发送对象 -->
          <el-table-column align="center" :label="$t('message.sendTo')" prop="send_realname" width="150">
          </el-table-column>
          <!-- 发送时间 -->
          <el-table-column align="center" :label="$t('message.sendingTime')" prop="MsgTime" width="150">
          </el-table-column>
          <!-- 聊天内容 -->
          <el-table-column align="center" :label="$t('message.chatContent')" prop="realname">
            <template slot-scope="scope">
              <div @dblclick="getComplainMessageContext(scope.row.id, scope.row.chat_type, scope.row.Text)"
                class="text-left">
                <recordTextEle :_elements="scope.row.MsgBodyText[0]" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 200, 500,]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <!-- 上下50条 -->
      <upAndDown ref="upAndDown" />
    </div>
  </div>
</template>
<script>
import recordTextEle from '@/components/common/messageElements/recordTextEle.vue'
import upAndDown from './upAndDown.vue'
export default {
  props: {
    id: { type: Number }
  },
  components: {
    recordTextEle,
    upAndDown
  },
  data() {
    return {
      datas: {
        user_id: '',
        keyword: '',
        page: 1,
        pageSize: 200,
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      upAndDownList: [],
    };
  },
  created() {

  },
  methods: {
    rakuchatMessageList() {

      this.$api.siteConfiguration.rakuchatMessageList(this.datas).then(res => {
        res.data.data.forEach(item => {
          if (this.datas.keyword) {
            item.Text = item.Text.replaceAll(this.datas.keyword, `<span style="color:#b4272d">${this.datas.keyword} </span>`)
          }
        })

        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      this.datas.page = 1
      this.rakuchatMessageList()
    },
    //
    reset() {
      this.datas = {
        user_id: '',
        keyword: '',
        datetimeStart: '',
        datetimeEnd: '',
        page: 1,
        pageSize: 200,
      }
      this.rakuchatMessageList()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.rakuchatMessageList()
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.rakuchatMessageList()
    },
    // RC聊天上下50条上下文
    getComplainMessageContext(id, chat_type, text) {
      this.$api.siteConfiguration.getRCComplainMessageContext({ id }).then(res => {
        this.$refs.upAndDown.upAndDownList = res.data
        this.$refs.upAndDown.dialogVisible = true
        this.$refs.upAndDown.type = chat_type
        this.$refs.upAndDown.text = text
      })

    }
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 24px;

  }

  .title {
    line-height: 40px;
    margin: 0 48px;
  }
}

.table {
  margin: 24px 0;


}

.text-left {
  text-align: left
}

.content {
  max-height: 650px;
  overflow-y: auto;
}
</style>